import { useContext, useRef } from "react";
import { GithubContext } from "../context/github/GithubContext";
import {
  exportComponentAsJPEG,
  exportComponentAsPDF,
  exportComponentAsPNG,
} from "react-component-export-image";
import {
  FaLocationArrow,
  FaRegStar,
  FaStar,
  FaUserCheck,
} from "react-icons/fa";
import { MdFavorite } from "react-icons/md";
import { Link } from "react-router-dom";
import { GoLocation } from "react-icons/go";
export const ProfileDownload = () => {
  const { dispatch, user, loading, repos, languages, langStats } =
    useContext(GithubContext);

  const sorted = repos

    .sort((a, b) => b["stargazers_count"] - a["stargazers_count"])
    .slice(0, 10);
  console.log(repos);
  const {
    name,
    type,
    avatar_url,
    location,
    bio,
    blog,
    twitter_username,
    login,
    html_url,
    followers,
    following,
    public_repos,
    public_gists,
    hireable,
  } = user;
  const link = useRef();
  return (
    <>
      <div
        data-theme="retro"
        className="container object-center col-auto lg:w-11/12 px-8 md:w-max  sm:w-max"
      >
        <div className="text-sm breadcrumbs">
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to={`/user/${login}`}>Go Back to profile</Link>
            </li>
            <li>Download</li>
          </ul>
        </div>
      </div>
      <div className="wrapper" ref={link}>
        <div className="profile-card js-profile-card  ">
          <div className="profile-card__img">
            <img src={avatar_url} alt={login} />
          </div>

          <div className="profile-card__cnt js-profile-cnt">
            <div className="profile-card__name">{name}</div>
            <div className="profile-card__txt">{bio}</div>
            <div className="profile-card-loc mb-3">
              <span className="profile-card-loc__icon">
                <GoLocation />
              </span>

              <span className="profile-card-loc__txt">
                <strong>{location}</strong>
              </span>
            </div>
            <div className="profile-card-loc">
              <span className="profile-card-loc__icon text-red-600">
                <MdFavorite />
              </span>

              <span className="profile-card-loc__txt text-black-900">
                <strong>{languages[0]}</strong>
              </span>
            </div>

            <div className="profile-card-inf">
              <div className="profile-card-inf__item">
                <div className="profile-card-inf__title">{followers}</div>
                <div className="profile-card-inf__txt">followers</div>
              </div>

              <div className="profile-card-inf__item">
                <div className="profile-card-inf__title">{public_repos}</div>
                <div className="profile-card-inf__txt">Public Repos</div>
              </div>

              <div className="profile-card-inf__item">
                <div className="profile-card-inf__title">
                  {repos[0].name}( {sorted[0].stargazers_count}{" "}
                  <span className=" profile-card-loc__icon ">
                    <FaStar />
                  </span>
                  )
                </div>
                <div className="profile-card-inf__txt">
                  <h2>Most Stared Repo</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        className="btn btn-warning items-center ml-32 mt-2 w-auto"
        onClick={() =>
          exportComponentAsPNG(link, {
            fileName: `${name}'s Github Profile`,
          })
        }
      >
        download
      </button>
    </>
  );
};
